import React from "react";
import {
  Bold,
  Button,
  Copy,
  Icon,
  InternalImage,
  Row,
  Card,
  Spin,
  Title,
  Wrapper
} from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";

import ButtonLayout from "./ButtonLayout";
import DrivingButton from "./DrivingButton";
import LocationButton from "./LocationButton";

import {
  getCustomFilterText,
  requestLocationPermission,
  openMobileSettings
} from "app/NativeActions";

const renderFilterText = props => {
  const custom_filter_text = getCustomFilterText(
    props.applied_highlights,
    true
  );
  if (custom_filter_text.length > 0) {
    return (
      <Wrapper
        style={{
          backgroundColor:
            props.dark_mode == "dark_mode"
              ? "rgba(31,41,51, 0.7)"
              : "rgba(255, 255, 255, 0.7)",
          paddingLeft: 15,
          paddingRight: 15
        }}
      >
        <Row>
          <Copy>
            <Bold>{custom_filter_text}</Bold>
          </Copy>
        </Row>
      </Wrapper>
    );
  }
};

const BottomButtons = props => {
  if (
    (!props.active_property && !props.active_address) ||
    (!props.isMobile &&
      props.device !== "mobile" &&
      props.user.team_clearance_level > 0)
  ) {
    if (props.route_plan_active && props.route_plan_legs) {
      return (
        <Wrapper>
          {props.route_plan_distance_left <= 0.03 ? (
            <Row
              style={{
                marginBottom: 0,
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <ButtonLayout
                onPress={() => {
                  props.getNextPlanned(
                    props.next_planned_property.property_data_id
                  );
                }}
                icon="navigate-next"
                text="Go To Next Property"
              />
            </Row>
          ) : (
            <Row
              style={{
                marginBottom: 0,
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <ButtonLayout
                onPress={() => {
                  props.setModal({
                    title:
                      "Are you sure you want to skip this planned property?",
                    description:
                      "Are you sure you want to skip and move on to the next property?",
                    submit: "Skip Property",
                    onPress: () => {
                      props.getNextPlanned(
                        props.next_planned_property.property_data_id
                      );
                    },
                    cancel: "Not yet",
                    onCancel: () => {}
                  });
                  props.toggleModal({ show: true, type: "normal" });
                }}
                icon="navigate-next"
                text="Skip Property"
              />
            </Row>
          )}
          <Row
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "auto",
              backgroundColor:
                props.dark_mode === "dark_mode" ? "#323F4B" : "#FFF",
              shadowColor: "#000",
              shadowRadius: 4,
              shadowOpacity: 0.3,
              shadowOffset: { width: 2, height: 2 },
              padding: 10,
              marginBottom: -10,
              elevation: 24,
              borderTopRightRadius: 20,
              borderTopLeftRadius: 20
            }}
          >
            <Button
              onPress={() =>
                props.selectActiveProperty(
                  props.token,
                  props.next_planned_property
                )
              }
            >
              <InternalImage
                //Todo replace with api key variable
                source={{
                  uri:
                    "https://maps.googleapis.com/maps/api/streetview?size=600x300&location=" +
                    encodeURIComponent(
                      props.next_planned_property.property_address_full
                    ) +
                    "&key=AIzaSyD5mDScNN4qLuQWg51msHJMzpH6ZxwM47o"
                }}
                resizeMode={"cover"}
                style={{
                  width: 100,
                  height: 100,
                  marginLeft: -10,
                  marginBottom: -5,
                  borderTopLeftRadius: 20,
                  marginTop: -10
                }}
              />
            </Button>

            <Wrapper style={{ flex: 1, paddingLeft: 8, paddingRight: 8 }}>
              <Title style={{ textAlign: "center" }}>
                <Copy
                  style={{
                    fontSize: 32,
                    color: props.dark_mode === "dark_mode" ? "#FFF" : "#004E64"
                  }}
                >
                  <Bold>{props.route_plan_distance_left.toFixed(2)}</Bold> mi
                </Copy>
              </Title>
              <Title style={{ textAlign: "center" }}>
                <Copy style={{ fontSize: 16, color: "#999" }}>
                  <Bold>{props.next_planned_property.property_address}</Bold>
                </Copy>
              </Title>
            </Wrapper>
            <Button
              style={{
                border: 1,
                borderColor: "#999",
                borderWidth: 1,
                borderRadius: 50,
                padding: 10,
                textAlign: "center"
              }}
              onPress={() => {
                if (props.current_route) {
                  props.setModal({
                    title: "Are you finished with your planned route?",
                    description:
                      "Are you sure you want to stop driving and complete your route?",
                    submit: "Stop Driving",
                    onPress: () => {
                      props.setCompletedRoute(false);
                      props.stopTrackedRoute({
                        token: props.token,
                        route_id: props.current_route.route_id,
                        coordinates: props.current_route_section
                          ? props.current_route_section.coordinates
                          : [],
                        current_route: props.current_route
                      });

                      if (props.route_plan_active) {
                        props.stopPlannedRoute({
                          token: props.token,
                          planned_route_id: props.planned_route_id
                        });
                      }
                    },
                    cancel: "Not yet",
                    onCancel: () => {}
                  });
                  props.toggleModal({ show: true, type: "normal" });
                }
              }}
            >
              <Icon
                color={props.dark_mode === "dark_mode" ? "#FFF" : "#000"}
                size={40}
                icon="close"
              />
            </Button>
          </Row>
        </Wrapper>
      );
    }

    if (props.reverse_geocode_loading) {
      return <ButtonLayout disabled spin text="Searching For Property..." />;
    }

    //map is loading
    if (props.map_properties_loading) {
      return <ButtonLayout disabled spin text="Searching Area..." />;
    }

    //user is too zoomed out
    if (props.showHighlightZoomMessage && props.showZoomMessage) {
      return (
        <Row
          style={{
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <ButtonLayout
            onPress={() => {
              props.zoomToMin();
            }}
            icon="zoom-in"
            text="Zoom In To View Routes & Properties"
          />
        </Row>
      );
    }
    if (props.showZoomMessage) {
      //if(props.lock_location_tracking){
      return (
        <Row
          style={{
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <ButtonLayout
            onPress={() => {
              props.zoomToMin();
            }}
            icon="zoom-in"
            text="Zoom In To View Properties"
          />
          {props.showHighlightZoomMessage ? (
            <ButtonLayout
              onPress={() => {
                props.refreshMap(true);
                props.getProperties({
                  load_type: "refresh"
                });
              }}
              style={{
                marginLeft: 0
              }}
              icon={props.number_of_properties > 0 ? "refresh" : "search"}
              text={
                props.number_of_properties > 0 ? "Refresh Area" : "Search Area"
              }
            />
          ) : null}
        </Row>
      );
      //}
      /*
            return(
              <Row style={{
                alignItems: "center",
                justifyContent: "center"
              }}>
                <ButtonLayout
                  onPress={()=>{
                    props.zoomToMin();
                  }}
                  style={{
                    marginRight: 0
                  }}
                  icon="zoom-in"
                  text="Zoom In To View Properties"
                />
                <ButtonLayout
                  onPress={()=>{
                    props.getProperties({
                      load_type: "refresh"
                    })
                  }}
                  icon="refresh"
                  text="Search Area"
                />
              </Row>
            )
            */
    }

    /*
        if(props.is_pan_dragging &&
          !props.lock_location_tracking){
          return(
            <ButtonLayout
              disabled
              icon="home"
              text="Properties will show upon release"

            />
          )
        }
        */

    if (props.lock_location_tracking) {
      return (
        <Row
          style={{
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <DrivingButton
            token={props.token}
            user={props.user}
            map_routes={props.map_routes}
            startTrackedRoute={props.startTrackedRoute}
            stopTrackedRoute={props.stopTrackedRoute}
            stopPlannedRoute={props.stopPlannedRoute}
            setModal={props.setModal}
            track_route={props.track_route}
            toggleModal={props.toggleModal}
            current_route={props.current_route}
            route_plan_active={props.route_plan_active}
            planned_route_id={props.planned_route_id}
            current_route_section={props.current_route_section}
            device={props.device}
            isMobile={props.isMobile}
            toggleActionSheet={props.toggleActionSheet}
          />
          <ButtonLayout
            onPress={() => {
              props.refreshMap(true);
              props.getProperties({
                load_type: "refresh"
              });
            }}
            icon={props.number_of_properties > 0 ? "refresh" : "search"}
            text={
              props.number_of_properties > 0 ? "Refresh Area" : "Search Area"
            }
          />
        </Row>
      );
    }

    return (
      <Wrapper
        style={{
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        {renderFilterText(props)}
        <Row
          style={{
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <DrivingButton
            token={props.token}
            user={props.user}
            map_routes={props.map_routes}
            startTrackedRoute={props.startTrackedRoute}
            stopTrackedRoute={props.stopTrackedRoute}
            stopPlannedRoute={props.stopPlannedRoute}
            setModal={props.setModal}
            track_route={props.track_route}
            toggleModal={props.toggleModal}
            current_route={props.current_route}
            current_route_section={props.current_route_section}
            device={props.device}
            isMobile={props.isMobile}
            toggleActionSheet={props.toggleActionSheet}
          />
          <ButtonLayout
            onPress={() => {
              props.refreshMap(true);
              props.getProperties({
                load_type: "refresh"
              });
            }}
            icon={props.number_of_properties > 0 ? "refresh" : "search"}
            text={
              props.number_of_properties > 0 ? "Refresh Area" : "Search Area"
            }
          />
        </Row>
        <LocationButton
          colors={props.colors}
          locationNotification={props.locationNotification}
          device={props.device}
          isMobile={props.isMobile}
        />
      </Wrapper>
    );
  }

  ///we have an active property and we're searching the area
  if (props.map_properties_loading && !props.lock_location_tracking) {
    return (
      <Wrapper
        style={{
          backgroundColor:
            props.dark_mode == "dark_mode"
              ? "rgba(31,41,51, 0.5)"
              : "rgba(255, 255, 255, 0.5)"
        }}
      >
        <Row>
          <Wrapper
            style={{
              alignItems: "center",
              justifyContent: "center",
              marginRight: 5
            }}
          >
            <Spin size="small" />
          </Wrapper>
          <Copy>
            <Bold>Searching Area...</Bold>
          </Copy>
        </Row>
      </Wrapper>
    );
  }

  return <Wrapper />;
};

export default React.memo(BottomButtons);
